export const DOC_CONFIG = {
    baseUrl: "http://192.168.10.10" // Apenas IP do Servidor onde ficarão fotos/áudios (rede dos equipamentos)
}
